import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import ContainedButton from 'components/Buttons/ContainedButton';
import Dialog from 'hoc/Dialog';
import PermissionIcon from 'components/Icons/PermissonIcon';
import WaitingIcon from 'components/Icons/WaitingIcon';
import WarningIcon from 'components/Icons/WarningIcon';

import { STATUS, UI_DATA } from 'parts/Assets/Dialogs/AcceptInfo';

const useStyles = makeStyles(theme => ({
  iconStyle: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    marginRight: theme.spacing(2),
  },
  panel: {
    gap: theme.spacing(1),
  },
  textPanel: {
    [theme.breakpoints.up('md')]: {
      minWidth: 440,
    },
  },
}));

export default function AcceptOfferDialog({
  status = STATUS.ACCEPT_BEFORE,
  open,
  setOpen,
  onClose,
  acceptHandler,
}) {
  const classes = useStyles();

  return (
    <Dialog title='Accept Offer' open={open} setOpen={setOpen}>
      <Box
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        className={classes.panel}>
        <Box display='flex'>
          {status === STATUS.ACCEPT_BEFORE ? (
            <PermissionIcon className={classes.iconStyle} />
          ) : status === STATUS.ACCEPT_WAITING ? (
            <WaitingIcon className={classes.iconStyle} />
          ) : status === STATUS.ACCEPT_ERROR ? (
            <WarningIcon className={classes.iconStyle} />
          ) : null}
          <div className={classes.textPanel}>
            <Typography>{UI_DATA[status].title}</Typography>
            <Typography>{UI_DATA[status].message}</Typography>
          </div>
        </Box>
        {status === STATUS.ACCEPT_BEFORE || status === STATUS.ACCEPT_WAITING ? (
          <ContainedButton
            variant='outlined'
            disabled={status === STATUS.ACCEPT_WAITING}
            onClick={acceptHandler}>
            Accept
          </ContainedButton>
        ) : status === STATUS.ACCEPT_ERROR ? (
          <ContainedButton variant='contained' onClick={onClose}>
            Close
          </ContainedButton>
        ) : null}
      </Box>
    </Dialog>
  );
}
